var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "facebook-square") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3---Account-Settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account-settings-oauth",
    transform: "translate(-420.000000, -800.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(406.000000, 676.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28-Copy",
    transform: "translate(0.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook-square",
    transform: "translate(14.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.08332031,0 L17.9166406,0 C19.0672656,0 20,0.932734375 20,2.08332031 L20,17.9166406 C20,19.0672656 19.0672656,20 17.9166797,20 L2.08332031,20 C0.932734375,20 0,19.0672656 0,17.9166797 L0,2.08332031 C0,0.932734375 0.932734375,0 2.08332031,0 Z",
    id: "Path",
    fill: "#3B5998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4166797,5.83332031 L17.0833594,5.83332031 C17.3134766,5.83332031 17.5000391,5.64675781 17.5000391,5.41664063 L17.5000391,2.91664063 C17.5000391,2.6865625 17.3134375,2.5 17.0833203,2.5 L15.4166406,2.5 C12.8853516,2.5 10.8333203,4.55203125 10.8333203,7.08332031 L10.8333203,9.16664063 L8.75,9.16664063 C8.51988281,9.16664063 8.33332031,9.35320313 8.33332031,9.58332031 L8.33332031,12.0833203 C8.33332031,12.3134375 8.51988281,12.5 8.75,12.5 L10.8333203,12.5 L10.8333203,20 L14.1666406,20 L14.1666406,12.5 L16.25,12.5 C16.4292578,12.4998828 16.5883594,12.3850781 16.645,12.215 L17.4783203,9.715 C17.5510547,9.49667969 17.4330078,9.26074219 17.2146875,9.18800781 C17.1723437,9.17390625 17.1279687,9.16667969 17.0833203,9.16664063 L14.1666406,9.16664063 L14.1666406,7.08332031 C14.1666797,6.39296875 14.7263281,5.83332031 15.4166797,5.83332031 Z",
    id: "Path",
    fill: "#FAFAFA"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSquare);
export default __webpack_public_path__ + "static/media/facebook-square.cb1433de.svg";
export { ForwardRef as ReactComponent };